/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".buttons[_ngcontent-%COMP%]{display:flex;flex-direction:row-reverse;flex-wrap:wrap}.buttons[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.payment-buttons[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr 1fr 1fr;-moz-column-gap:10px;column-gap:10px;row-gap:40px}.payment-buttons[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin:0;text-align:center}\n/*# sourceMappingURL=competitor-registration.component.css.map*/"];
export { styles as styles };
